import {
  OPEN_REJECT_LAB_ORDER_MODAL,
  OPEN_ACCEPT_LAB_ORDER_MODAL,
  OPEN_SHOW_PRESCRIPTION_MODAL,
  OPEN_LAB_ORDER_SAMPLING_MODAL,
  OPEN_HOME_CARE_ORDER_SAMPLING_MODAL,
  OPEN_LAB_ORDER_GENERAL_RESULT_MODAL,
  OPEN_LAB_ORDER_DIRECT_RESULT_MODAL,
  OPEN_LAB_ORDER_LINK_RESULT_MODAL,
  OPEN_LAB_ORDER_FILE_RESULT_MODAL,
  OPEN_LAB_ORDER_FINISH_MODAL,
  OPEN_LAB_ORDER_SAFE_CALL_MODAL,
  OPEN_PHARMACY_ORDER_READY_MODAL,
  OPEN_PHARMACY_ORDER_REJECT_MODAL,
  OPEN_PHARMACY_ORDER_ACCEPT_MODAL,
  OPEN_PHARMACY_ORDER_PARTIAL_MODAL,
    OPEN_PHARMACY_ORDER_GENERAL_ACCEPT_MODAL
} from "../actions/modals";

const initialState = {
  reject_lab_order_open: false,
  lab_order_reject: {
    prescriptions: [],
    products: [],
  },
  accept_lab_order_open: false,
  lab_order_accept: {
    prescriptions: [],
    products: [],
  },
  show_prescription_open: false,
  show_prescription_url: "",
  sampling_lab_order_open: false,
  sampling_lab_order: {
    prescriptions: [],
    products: [],
  },
  general_lab_result_order_open: false,
  general_result_lab_order: {
    prescriptions: [],
    products: [],
  },
  direct_lab_result_order_open: false,
  direct_result_lab_order: {
    prescriptions: [],
    products: [],
  },
  direct_result_lab_order_form : {
    to : '',
    by : ''
  },
  link_lab_result_order_open: false,
  link_result_lab_order: {
    prescriptions: [],
    products: [],
  },
  link_result_lab_order_form : {
    links : []
  },
  file_lab_result_order_open: false,
  file_result_lab_order: {
    prescriptions: [],
    products: [],
  },
  lab_order_finish_open: false,
  lab_order_finish_order: {
    prescriptions: [],
    products: [],
  },
  order_safe_call_open: false,
  order_safe_call_order: {
    prescriptions: [],
    products: [],
  },
  pharmacy_order_ready_open: false,
  pharmacy_order_ready_order: {
    prescriptions: [],
    products: [],
  },
  pharmacy_order_reject_open: false,
  pharmacy_order_reject_order: {
    prescriptions: [],
    products: [],
  },
  pharmacy_order_general_accept_open: false,
  pharmacy_order_general_accept_order: {
    prescriptions: [],
    products: [],
  },
  pharmacy_order_accept_open: false,
  pharmacy_order_accept_order: {
    prescriptions: [],
    products: [],
  },
  pharmacy_order_accept_type: 'simple',
  pharmacy_order_partial_open: false,
  pharmacy_order_partial_order: {
    prescriptions: [],
    products: [],
  },
  pharmacy_order_partial_type: 'simple'
};

export default function modals(state = initialState, action) {
  switch (action.type) {
    case OPEN_REJECT_LAB_ORDER_MODAL:
      return {
        ...state,
        reject_lab_order_open: action.open,
        lab_order_reject: action.order,
      };
    case OPEN_ACCEPT_LAB_ORDER_MODAL:
      return {
        ...state,
        accept_lab_order_open: action.open,
        lab_order_accept: action.order,
      };
    case OPEN_SHOW_PRESCRIPTION_MODAL:
      return {
        ...state,
        show_prescription_open: action.open,
        show_prescription_url: action.url,
      };
    case OPEN_LAB_ORDER_SAMPLING_MODAL:
      return {
        ...state,
        sampling_lab_order_open: action.open,
        sampling_lab_order: action.order,
      };
    case OPEN_HOME_CARE_ORDER_SAMPLING_MODAL:
      return {
        ...state,
        sampling_home_care_order_open: action.open,
        sampling_home_care_order: action.order,
      };
    case OPEN_LAB_ORDER_GENERAL_RESULT_MODAL:
      return {
        ...state,
        general_lab_result_order_open: action.open,
        general_result_lab_order: action.order,
      };
    case OPEN_LAB_ORDER_DIRECT_RESULT_MODAL:
      return {
        ...state,
        direct_lab_result_order_open: action.open,
        direct_result_lab_order: action.order,
        direct_result_lab_order_form : action.form
      };
    case OPEN_LAB_ORDER_LINK_RESULT_MODAL:
      return {
        ...state,
        link_lab_result_order_open: action.open,
        link_result_lab_order: action.order,
        link_result_lab_order_form : action.form
      };
    case OPEN_LAB_ORDER_FILE_RESULT_MODAL:
      return {
        ...state,
        file_lab_result_order_open: action.open,
        file_result_lab_order: action.order,
      };
    case OPEN_LAB_ORDER_FINISH_MODAL:
      return {
        ...state,
        lab_order_finish_open: action.open,
        lab_order_finish_order: action.order,
      };
    case OPEN_LAB_ORDER_SAFE_CALL_MODAL:
      return {
        ...state,
        order_safe_call_open: action.open,
        order_safe_call_order: action.order,
      };
    case OPEN_PHARMACY_ORDER_READY_MODAL:
      return {
        ...state,
        pharmacy_order_ready_open: action.open,
        pharmacy_order_ready_order: action.order,
      };
    case OPEN_PHARMACY_ORDER_REJECT_MODAL:
      return {
        ...state,
        pharmacy_order_reject_open: action.open,
        pharmacy_order_reject_order: action.order,
      };
    case OPEN_PHARMACY_ORDER_GENERAL_ACCEPT_MODAL:
      return {
        ...state,
        pharmacy_order_general_accept_open: action.open,
        pharmacy_order_general_accept_order: action.order,
      };
    case OPEN_PHARMACY_ORDER_ACCEPT_MODAL:
      return {
        ...state,
        pharmacy_order_accept_open: action.open,
        pharmacy_order_accept_order: action.order,
        pharmacy_order_accept_type: action.accept_type,
      };
      case OPEN_PHARMACY_ORDER_PARTIAL_MODAL:
        return {
          ...state,
          pharmacy_order_partial_open: action.open,
          pharmacy_order_partial_order: action.order,
          pharmacy_order_accept_type: action.accept_type,
        };
    default:
      return state;
  }
}
